import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urls from '../utilities/urls';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private httpClient: HttpClient) { }

  // Get Role Details by ID after Login
getRoleDetailsById() {
  return this.httpClient.get(urls.rolesDetailUrls.roleDetails);
}
}
